<template>
  <svg width="81" height="80" viewBox="0 0 81 80" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1013_203334)">
      <path
        d="M40.19 10.08C40.288 10.0263 40.3982 9.99871 40.51 10C40.6201 9.99957 40.7284 10.0271 40.825 10.08C40.9393 10.1486 41.0327 10.2471 41.095 10.365L75.38 68.7C75.56 69 75.555 69.32 75.39 69.615C75.3266 69.7361 75.2337 69.8392 75.12 69.915C75.021 69.9757 74.906 70.0053 74.79 70H6.22997C6.11391 70.0057 5.99886 69.976 5.89997 69.915C5.78624 69.8392 5.6934 69.7361 5.62997 69.615C5.54758 69.4762 5.50493 69.3175 5.50669 69.1561C5.50846 68.9947 5.55456 68.8369 5.63997 68.7L39.92 10.365C39.9825 10.2473 40.0758 10.1488 40.19 10.08ZM45.41 7.83C44.915 6.96782 44.2014 6.2515 43.341 5.75337C42.4807 5.25523 41.5041 4.99292 40.51 4.99292C39.5158 4.99292 38.5393 5.25523 37.6789 5.75337C36.8186 6.2515 36.1049 6.96782 35.61 7.83L1.32497 66.165C-0.960026 70.055 1.77997 75 6.22497 75H74.79C79.235 75 81.98 70.05 79.69 66.165L45.41 7.83Z"
       :fill="color" />
      <path
        d="M35.51 60C35.51 59.3434 35.6393 58.6932 35.8906 58.0866C36.1419 57.4799 36.5102 56.9288 36.9744 56.4645C37.4387 56.0002 37.9899 55.6319 38.5966 55.3806C39.2032 55.1293 39.8534 55 40.51 55C41.1666 55 41.8168 55.1293 42.4234 55.3806C43.03 55.6319 43.5812 56.0002 44.0455 56.4645C44.5098 56.9288 44.8781 57.4799 45.1294 58.0866C45.3806 58.6932 45.51 59.3434 45.51 60C45.51 61.3261 44.9832 62.5978 44.0455 63.5355C43.1078 64.4732 41.8361 65 40.51 65C39.1839 65 37.9121 64.4732 36.9744 63.5355C36.0368 62.5978 35.51 61.3261 35.51 60ZM36 29.975C35.9334 29.3442 36.0002 28.7065 36.196 28.1031C36.3918 27.4998 36.7122 26.9444 37.1366 26.4729C37.5609 26.0015 38.0796 25.6245 38.659 25.3664C39.2385 25.1084 39.8657 24.975 40.5 24.975C41.1343 24.975 41.7615 25.1084 42.3409 25.3664C42.9204 25.6245 43.4391 26.0015 43.8634 26.4729C44.2877 26.9444 44.6082 27.4998 44.804 28.1031C44.9998 28.7065 45.0666 29.3442 45 29.975L43.25 47.51C43.1912 48.1989 42.876 48.8406 42.3668 49.3082C41.8575 49.7758 41.1913 50.0353 40.5 50.0353C39.8086 50.0353 39.1424 49.7758 38.6332 49.3082C38.124 48.8406 37.8088 48.1989 37.75 47.51L36 29.975Z"
       :fill="color" />
    </g>
    <defs>
      <clipPath id="clip0_1013_203334">
        <rect width="80" height="80" :fill="color" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B7A3FF',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
